export default __webpack_public_path__ + "static/media/school-default-icon.3e29aebb.svg";